
import React from 'react';
import { timestamp_sec_to_mmddyy_hhmmss } from "../../../lib/time";
import { sprintf } from "sprintf-js";
import {deep_copy} from "../../../lib/js-utils";

const label_value = (label, value) => {
  const label_style = {
    fontWeight: "bold",
    paddingRight: "1rem",
  }
  return (
    <div>
      <span style={label_style}>{label}</span><span>{value}</span>
    </div>
  )
}


const render_menu = (component, notif) => {

  const on_change = (ev) => {
    const id = ev.target.id;
    const val = ev.target.value;
    const do_csv = deep_copy(component.state.do_csv);
    do_csv[id] = val;
    component.setState({ do_csv });
  }

  const id = notif.id;
  const val = component.state.do_csv[id];
  const style = {
    fontSize: "1.5rem",
    padding: "0.5rem 2rem",
  }
  return (
    <div>
      <select
        style={style}
        id={id} onChange={on_change} value={val}>
        <option key={'yes'} value={'yes'}>
          Dump CSV
        </option>
        <option key={'no'} value={'no'}>
          Skip CSV
        </option>
      </select>
    </div>
  )
}

const render_header = (notif, name, component) => {

  const header_style = {
    display: "flex",
  }

  const request_str = timestamp_sec_to_mmddyy_hhmmss(notif.requested);
  let username_str;
  if (notif.username_index) {
    const user_re = /^(.*)_(\d{4})$/;
    const match = notif.username_index.match(user_re);
    if (!match) {
      username_str = "Error";
    } else {
      username_str = sprintf("%s - %d", match[1], parseInt(match[2], 10));
    }
  } else {
    username_str = sprintf("%s - %d", notif.username, notif.index);
  }
  const container_style = {
    paddingTop: "1rem",
    paddingBottom: "1rem",
  }

  const active_menu = component.state.do_csv
    ? render_menu(component, notif)
    : null;

  return (
    <div style={container_style}>
      <div style={header_style}>
        <div style={{flex: "1"}}>
          { request_str }
        </div>
        <div style={{ flex: "1", display: "flex"}}>
          <div>
           { label_value("Queue ID:", notif.id) }
          </div>
          <div style={{ flex: "1"}}/>
          <div>{active_menu}</div>
        </div>
      </div>
      <div style={header_style}>
        <div style={{flex: "1"}}>
          <div>{ username_str }</div>
          { name && <div>{name}</div> }
        </div>
        <div style={{ flex: "1"}}>
          { label_value("Account Number:", notif.metadata && notif.metadata.account_number) }
          { label_value("Account Type:", notif.metadata.account_type) }
        </div>
      </div>

    </div>
  )
}

export { render_header };
